export default "__VITE_ASSET__220589ad__"